import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, Home, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const NotAuthorized = ({ requiredPermission, requiredRole }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <ShieldX className="mx-auto h-16 w-16 text-red-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600">
            You don't have permission to access this feature.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="text-sm text-gray-700">
            <p className="mb-2">
              <strong>Your Role:</strong> {user?.role || 'Unknown'}
            </p>
            {requiredPermission && (
              <p className="mb-2">
                <strong>Required Permission:</strong> {requiredPermission.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              </p>
            )}
            {requiredRole && (
              <p>
                <strong>Required Role:</strong> {requiredRole}
              </p>
            )}
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700 flex items-center justify-center gap-2 transition-colors"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full text-white py-2 px-4 rounded-lg hover:opacity-90 flex items-center justify-center gap-2 transition-colors"
            style={{backgroundColor: '#00C5CB'}}
          >
            <Home size={16} />
            Go to Dashboard
          </button>
        </div>

        <div className="mt-6 text-xs text-gray-500">
          <p>If you believe this is an error, please contact your administrator.</p>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;